import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  BookingLMApiService,
  BookingShipmentLMApi,
  CodeNameOrderIconLMApi,
  CodeNameOrderLMApi,
  GetInfoInputLMApi,
  NewBookingResponseLMApi,
  ShipmentInfoLMApi,
  ShipmentLMApiService,
  EditBookingRequestLMApi,
  EditBookingResponseLMApi,
  AdvanceStatusInputLMApi,
  OptionalsLMApi,
  DeleteBookingRequestLMApi,
} from 'src/app/api';
import { BookingService } from 'src/app/services/booking.service';
import { mapForPostMessageShipmentModel } from 'src/app/services/utils';

@Component({
  selector: 'app-edit-add-reason',
  templateUrl: 'edit-add-reason.component.html',
})
export class EditAddReasonComponent {
  title: string = 'ADDREASON_TITLE';

  error: string | undefined;
  loaded: boolean = false;

  editReasonSelectTypes: CodeNameOrderLMApi[] | null | undefined = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public bookingService: BookingService,
    private apiService: BookingLMApiService,
    private shipmentApiService: ShipmentLMApiService,
    private translateService: TranslateService
  ) {
    //Se provengo da pagina di conferma modifica rimando ad inizio fase di modifica
    if (this.router.lastSuccessfulNavigation && /\/view\/.*\/c/.test(this.router.lastSuccessfulNavigation.initialUrl.toString()))
      window.location.reload();
    
    this.title = bookingService.toDelete ? 'DELETE_SHIPMENT' : 'ADDREASON_TITLE';

    if (!this.bookingService.data || !this.bookingService.editInitialBookingDate) {
      this.router.navigate(['.'], { relativeTo: this.route.parent });
    }
    this.bookingService.setStepperActive(3);
    this.editReasonSelectTypes = bookingService.toDelete ? this.bookingService.warehouseConfiguration.deleteReasonTypes : this.bookingService.warehouseConfiguration.reasonTypes;
  }

  goBack = () => {
    if (this.bookingService.toDelete) {
      this.router.navigate(['/edit/' + this.bookingService.data.code]);
    } else this.router.navigate(['.'], { relativeTo: this.route.parent });
  };

  alreadyClicked = false;
  edit(event: Event) {
    this.alreadyClicked = true;
    (<HTMLButtonElement>document.getElementById("goBackBtn")).disabled = true;
    const target = <HTMLButtonElement>event.currentTarget;
    const elem: Element = document.createElement('div');
    elem.className = 'spinner-border m-auto';
    const temp = target.replaceChildren(elem);
    this.error = undefined;
    let data = this.bookingService.data;
    let bookingShipment: BookingShipmentLMApi = {
      ...data,
      carrier: data.carrier?.toUpperCase(),
      notes: data.notes?.toUpperCase(),
      referenceName: data.referenceName?.toUpperCase(),
      referenceNumber: data.referenceNumber?.toUpperCase(),
      secReferenceNumber: data.secReferenceNumber?.toUpperCase(),
      sender: data.sender?.toUpperCase(),
      receiver: data.receiver?.toUpperCase(),
      truckPlate: data.truckPlate?.toUpperCase(),
      trailerPlate: data.trailerPlate?.toUpperCase(),
      cdn: data.referenceNumber?.toUpperCase(),
      external: data.secReferenceNumber?.toUpperCase(),
      startDT: this.bookingService.selectedSlot?.from!,
      endDT: this.bookingService.selectedSlot?.to!,
      gateCode: this.bookingService.selectedSlot?.code,
      filePath: this.bookingService.bookingFileTempPath,
    };
    let updateShipmentRequest: EditBookingRequestLMApi = {
      shipment: bookingShipment,
      reason: this.bookingService.reason,
      reasonTypeCode: this.bookingService.reasonTypeCode,
      who: this.bookingService.myBookingsWho,
    };

    this.apiService.editBooking(this.bookingService.selectedWarehouseData?.token!, updateShipmentRequest).subscribe((x: EditBookingResponseLMApi) => {
      if (x && x.shipmentCodeCrypted) {
        if (window.location !== window.parent.location) {
          // The page is an iframe
          //API PER GETINFO e poi mandare POSTMESSAGE e andare su view
          this.shipmentApiService.getInfo(this.bookingService.token!.key!, { bookingCode: x.shipmentCodeCrypted } as GetInfoInputLMApi).subscribe((info: ShipmentInfoLMApi) => {
            if (info) {
              window.parent.postMessage(JSON.stringify(mapForPostMessageShipmentModel(info, this.bookingService.selectedWarehouseData!)), '*');
              this.router.navigateByUrl('/view/' + x.shipmentCodeCrypted + '/c', { state: { fromRoute: 'edit' } });
            }
          });
        } else {
          this.router.navigateByUrl('/view/' + x.shipmentCodeCrypted + '/c', { state: { fromRoute: 'edit' } });
        }
      } else if (x && x.error) {
        this.error = x.error;
        //restore go next and go back button
        const elems = [document.createElement('i'), document.createElement('span')];
        elems[0].className = 'bi bi-check-lg';
        elems[1].innerHTML = this.translateService.instant('STEPPER_COMPLETE');
        const goNextBtn = (<HTMLButtonElement>document.getElementById("goNextBtn"));
        goNextBtn.replaceChildren(...elems);
        (<HTMLButtonElement>document.getElementById("goBackBtn")).disabled = false;
      }
    });
  }

  delete(event: Event) {
    this.alreadyClicked = true;
    const target = <HTMLButtonElement>event.currentTarget;
    const elem: Element = document.createElement('div');
    elem.className = 'spinner-border m-auto';
    const temp = target.replaceChildren(elem);

    let data = this.bookingService.data;
    let bookingShipment: BookingShipmentLMApi = {
      ...data,
      carrier: data.carrier?.toUpperCase(),
      notes: data.notes?.toUpperCase(),
      referenceName: data.referenceName?.toUpperCase(),
      referenceNumber: data.referenceNumber?.toUpperCase(),
      secReferenceNumber: data.secReferenceNumber?.toUpperCase(),
      sender: data.sender?.toUpperCase(),
      receiver: data.receiver?.toUpperCase(),
      truckPlate: data.truckPlate?.toUpperCase(),
      trailerPlate: data.trailerPlate?.toUpperCase(),
      cdn: data.referenceNumber?.toUpperCase(),
      external: data.secReferenceNumber?.toUpperCase(),
      startDT: this.bookingService.selectedSlot?.from!,
      endDT: this.bookingService.selectedSlot?.to!,
      gateCode: this.bookingService.selectedSlot?.code,
      filePath: this.bookingService.bookingFileTempPath,
    };
    let updateShipmentRequest: DeleteBookingRequestLMApi = {
      shipment: bookingShipment,
      reason: this.bookingService.reason,
      reasonTypeCode: this.bookingService.reasonTypeCode,
      who: this.bookingService.myBookingsWho,
    };

    this.apiService.deleteBooking(this.bookingService.selectedWarehouseData?.token!, updateShipmentRequest).subscribe((x: EditBookingResponseLMApi) => {
      if (x && x.shipmentCodeCrypted) {
        this.router.navigate(['/deleted']);
      } else if (x && x.error) {
        this.error = x.error;
      }
    });
  }

  goNext = (event: Event) => {
    this.bookingService.toDelete ? this.delete(event) : this.edit(event);
  };
}
